<template>
    <unique-id
        v-slot="{ id }"
        tag-name="div"
        v-bind="$attrs"
        class="collapsible"
    >
        <div class="u-flex">
            <a
                :id="`${id}-trigger`"
                class="collapsible__headline qa-collapsible-trigger u-inline-block p-12"
                :href="`#${id}`"
                :aria-controls="id"
                :aria-expanded="`${isOpen}`"
                @click.prevent="toggleContent"
            >
                <app-icon
                    hidden
                    :name="isOpen ? 'diff-removed' : 'diff-added'"
                    class="collapsible__headline-icon mr-6 u-flex-no-shrink"
                />

                <component :is="`h${headlineLevel}`" class="collapsible__headline-text m-0">{{ headline }}</component>
            </a>
            <slot name="headlineAction" />
        </div>
        <slide-up-down :active="isOpen" :duration="200">
            <div
                :id="id"
                :aria-labelledby="`${id}-trigger`"
                role="region"
                class="collapsible__content p-12"
            >
                <slot />
            </div>
        </slide-up-down>
    </unique-id>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
import AppIcon from '@/components/ui/Icon.vue'
import UniqueId from '@/components/UniqueId'

export default {
    components: { UniqueId, AppIcon, SlideUpDown },

    props: {
        // Allows v-model for open status:
        value: { type: Boolean, default: false },
        headline: { type: String, required: true },
        headlineLevel: { type: Number, default: 2 },
    },

    data () {
        return {
            isOpen: this.value,
        }
    },

    watch: {
        value (newValue) {
            this.isOpen = newValue
        },
    },

    methods: {
        toggleContent () {
            this.isOpen = !this.isOpen
            this.$emit('input', this.isOpen)
        },
    },
}
</script>

<style lang="scss" scoped>
$border-color: darken($tertiary-color, 5%);

.collapsible {
    background: $border-color;

    &__headline {
        width: 100%;
        border-top: 1px solid $border-color;
        border-left: 1px solid $border-color;
        border-right: 1px solid $border-color;
    }

    &__headline-icon {
        position: relative;
        top: -2px; /* Align with text */
    }

    &__headline-text {
        display: inline-block;
    }

    &__content {
        background: $white;
        border-left: 1px solid $border-color;
        border-right: 1px solid $border-color;
        border-bottom: 1px solid $border-color;
    }
}
</style>
